<p-card>
  <ng-template #title>{{ gateway().name || 'N/A' }}</ng-template>
  <ng-template #subtitle>{{ ('devices.types.' + gateway().deviceType | translate) || gateway().deviceType || ('cards.gateway.subtitle' | translate) }}</ng-template>

  @if (extended() && (gateway().mac || gateway().ref)) {
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-qrcode"></i></div>
      <div class="item-text">
        <div class="item-title">{{ gateway().mac || gateway().ref || 'N/A' }}</div>
        <div class="item-line">ID</div>
      </div>
    </div>
  }

  @if ((project() || extended()) && gateway().project) {
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-folder-open"></i></div>
      <div class="item-text">
        <div class="item-title">{{ gateway().project?.name || 'N/A' }}</div>
        <div class="item-line">{{ "cards.gateway.project" | translate }}</div>
      </div>
    </div>
  }

  @if (connection() || extended()) {
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-clock"></i></div>
      <div class="item-text">
        <div class="item-title">
          @if (gateway().lastSeenAt || gateway().chirpstackMetadata?.lastSeenAt) {
            <span>{{ (gateway().lastSeenAt || gateway().chirpstackMetadata?.lastSeenAt) | date:'dd/MM/yyyy HH:mm' }}</span>
          }
          @if (!gateway().lastSeenAt && !gateway().chirpstackMetadata?.lastSeenAt) {
            <span>{{ "landing.gateway-status.never" | translate }}</span>
          }
        </div>
        <div class="item-line">{{ "landing.gateway-status.last_seen" | translate }}</div>
      </div>
    </div>

    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-rss"></i></div>
      <div class="item-text">
        <div class="item-title">
          @if (timeComparison(gateway()) <= 360000) {
            <span class="green">● {{ "landing.gateway-status.good" | translate }}</span>
          }
          @if (timeComparison(gateway()) > 360000) {
            <span class="red">● {{ "landing.gateway-status.bad" | translate }}</span>
          }
        </div>
        <div class="item-line">{{ "landing.gateway-status.connection" | translate }}</div>
      </div>
    </div>
  }

  @if (showNavigation() && resolvedProjectId()) {
    <ng-template #footer>
      <button pButton color="primary" routerLink="/projects/{{ resolvedProjectId() }}/monitoring/devices/{{ gateway()._id }}">{{ "button.details" | translate }}</button>
    </ng-template>
  }

  @if (extended() && latestTransmissions(); as transmissions) {
    <p-divider></p-divider>
    <p-panel [toggleable]="true">
      <ng-template #header>
        <i [class]="'mx-2 ' + getTransmissionDetails(transmissions[0])[1]"
          [attr.style]="'color:' + getTransmissionDetails(transmissions[0])[0]"></i>
        {{ getTransmissionDetails(transmissions[0])[2] }}
      </ng-template>
      @for (transmission of transmissions; track transmission) {
        <div>
          <p class="py-2">
            {{ transmission.timestamp | date:'dd/MM/yyyy HH:mm:ss' }} - {{ getTransmissionDetails(transmission)[2] }}
            @if (transmission.data?.temperature !== undefined) {
              - Data: {{ transmission.data.temperature }} ºC
            }
            <p-divider></p-divider>
          </p>
        </div>
      }
    </p-panel>
  }
</p-card>
